import { PdfJobStatus } from "@prisma/client";

export const pdfJobsQueryKeys = {
  all: ["automated-pdf"] as const,
  list: () => [...pdfJobsQueryKeys.all, "list"] as const,
  get: (jobType: PdfJobStatus) =>
    [...pdfJobsQueryKeys.all, "get", jobType] as const,
};
